/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import { toCalendarEventProps } from './translator/calendar'
import { toQuery } from './translator/query'
import { IQueryProps } from '@/entities/Query'
import { FetchCalendarEvents } from '@/infrastructure/network/Monitaro/requests/calendar'

export default class Calendar extends MonitaroGatewayBase {
  async FetchCalendarEvents(query?: IQueryProps) {
    const { events } = await this.apiClient.request(new FetchCalendarEvents(toQuery(query)))
    return events?.map(toCalendarEventProps) || []
  }
}
